import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useApi, useAuth } from "../../../hooks";
import { ServicesApi } from "../../../apis";
import { Enums } from "../../../utils";

const useViewModel = () => {
  const activationSuccessModalRef = useRef({ open: () => {}, close: () => {} });
  const [loading, setLoading] = useState(false);
  const { isAuthenticated } = useAuth();
  const [data, setData] = useState({});
  const { uuid = "" } = useParams();
  const navigate = useNavigate();
  const { execute } = useApi();

  useEffect(() => {
    if (isAuthenticated) getData(uuid);
  }, [uuid, isAuthenticated]);

  const getData = useCallback(
    async (id, { loading = true, showError = false } = {}) => {
      try {
        const data = await execute(() => ServicesApi.license(id), {
          setLoading: (state) => setLoading(state && loading),
          showError,
        });
        setData(data);
      } catch (error) {}
    },
    [uuid]
  );

  const activateLicense = async () => {
    const { id } = await execute(() =>
      ServicesApi.activateLicense(data.licenseKey)
    );
    activationSuccessModalRef.current.open({ id });
  };

  return {
    data,
    loading,
    params: { uuid },
    isAuthenticated,
    refs: { activationSuccessModal: activationSuccessModalRef },
    getData,
    activateLicense,
    onActivationSuccess: (id) =>
      navigate(`../${Enums.pagesNames.subscription}/${id}`),
  };
};

export default useViewModel;
